import React from "react";
import { Routes, Route } from "react-router-dom";
import Feedback from "../pages/Feedback/Feedback";
import NotFound from "../pages/NotFound";

const FeedbackRoutes = () => {
  return (
    <Routes>
      {/* Redirect /feedback to home if no token is provided */}
      <Route exact path="/:businessToken" element={<Feedback />} />
      <Route path="*" element={<NotFound message="404: Feedback Page Not Found" />} />
    </Routes>
  );
};

export default FeedbackRoutes;
